import React from "react";
import ConnectorTypeContainer from "containers/ConnectorType/index";

const ConnectorTypePage = () => {
  return (
    <>
    
      <ConnectorTypeContainer />
    </>
  );
};

export default ConnectorTypePage;